import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { push } from 'redux-router';
import constants from 'constants';
import actions from 'actions';
import storage from 'services/storage';

const {
  updateUser
} = actions;

const {
  CONFIRM_EMAIL_SAGA,
  API_CONFIRM_EMAIL
} = constants;

const apiConfirmEmail = (token) => (
  axios.put(`${API_CONFIRM_EMAIL}/${token}`, {
    token
  })
)

const writeAuthSessionToStorage = (user, session) => {
  storage.setSessionData(user, session)
}

function* confirmEmail({ token }) {
  try {
    const response = yield call(apiConfirmEmail, token);
    const user = response.data.user;
    const session = {
      token: response.data.token
    };
    yield put(updateUser(user, session))
    yield call(writeAuthSessionToStorage, user, session);


    // Deprecated - redirect works without this f, leaving as backup.
    // setTimeout(function* () {
    // }, 500)
    yield call(toast.success, 'Your email address has been confirmed')
    yield put(push('/users/profile?token=' + token));
  } catch (e) {
    yield call(toast.warning, 'Invalid email confirmation token.')
    yield put(push('/'));
  }
}

function* __confirmEmailSaga() {
  yield takeEvery(CONFIRM_EMAIL_SAGA, confirmEmail);
}

export { __confirmEmailSaga }



// WEBPACK FOOTER //
// ./src/sagas/confirmEmail.js